export default __webpack_public_path__ + "static/media/bcoin.a778521c.png";